import { render, staticRenderFns } from "./XLLDetail.vue?vue&type=template&id=3dae65df&scoped=true"
var script = {}
import style0 from "./XLLDetail.vue?vue&type=style&index=0&id=3dae65df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae65df",
  null
  
)

export default component.exports